const CUSTOM_USER_NOTIFICATIONS_FORM = {
    title: {
        text: 'custom_user_notifications.title'
    },
    submit: {
        label: 'custom_user_notifications.submit_btn'
    },
    fields: [
        {
            name: 'title',
            label: 'custom_user_notifications.title_field',
            type: 'text',
            defaultValue: '',
            validators: ['required'],
            errors: ['errors.required_title'],
        },
        {
            name: 'body',
            label: 'custom_user_notifications.body_field',
            type: 'text-editor',
            defaultValue: ''
        }
    ]
}

export default CUSTOM_USER_NOTIFICATIONS_FORM;
